<template>
  <div v-if="showPage" class="custom-icon-wrapper" @click="clickHandler" :class="attr['cls']?.['name']" :style="style">
    <div v-if="!isSvg">
      <img :src="getIconUrl()" alt="" class="custom-icon" @error="handleError" :style="{
        width: iconConfig.size + 'px',
        height: iconConfig.size + 'px'
      }" />
    </div>
    <div v-else class="svg-icon" :style="{
      width: iconConfig.size + 'px',
      height: iconConfig.size + 'px',
      maskImage: `url(${getIconUrl()})`,
      WebkitMaskImage: `url(${getIconUrl()})`,
      backgroundColor: iconConfig.color
    }"></div>
  </div>
</template>

<script setup lang="ts">
/**
 * 自定义图标组件
 * @component CustomIcon
 * @description 用于显示网络图标的组件，支持自定义大小和错误处理
 */

import { computed, reactive, ref } from 'vue';

import { exeAction, getPid } from 'exeAction-utils';

import mitt from 'mitt-utils';
import { useRoute, useRouter } from 'vue-router';
import { genStyle } from '../../actionUtils/cssUtils';

const router = useRouter();
const route = useRoute();
let showPage = ref(true);
let pid = getPid(route);

// 定义组件属性
const props = defineProps({
  config: {
    type: Object,
    default: {}
  },
  frontId: {
    type: Number,
    default: 0
  },
  paramFormData: {
    type: String,
    default: null
  }
}
)
let { did, attr = {}, blur = {}, change = {}, click = {}, pop = {}, iconUrl } = props.config;
const { css = {}, mcss = {} } = attr;
// 图标整体样式实现
let style = ref(genStyle(attr));

const iconConfig = reactive({
  type: attr['cic_tp'], // 图标类型
  size: attr['cic_sz'], // 图标大小
  iconUrl: attr['cic_url'], // 图标URL
  color: attr['cic_c']  // 图标颜色
});

const getIconUrl = (): string => {
  if (iconConfig.type == 3) {
    return `./icon/${props.paramFormData}.svg`;
  } else if (iconConfig.type == 1) {
    return `./icon/${iconConfig.iconUrl}.svg`;
  } else if (iconConfig.type == 2) {
    return `./icon/${iconConfig.iconUrl}`;
  } else if (iconConfig.type == 0) {
    return iconConfig.iconUrl;
  }
}

// 判断是否为SVG图标
const isSvg = computed(() => {
  return getIconUrl().indexOf('.svg') != -1;
});


// 图片加载错误处理
// 关闭方法, 这个判断有时会出问题, 图片可以加载 但是出发了handleError
const handleError = (e: Event) => {
  const target = e.target as HTMLImageElement;
  // target.style.display = 'none';
  console.error('图标加载失败:', attr['cic_url']);
};



const clickHandler = () => {
  if (click) {
    exeAction(router, click, {}, pid, props.frontId);
  }
}
let mittName = `${pid}_mitt_did_${did}`;
mitt.on(mittName, (par: any) => {
  console.log("custOmIcon.vue 表单监听", par);
  if (par['flg'] === 'open') {
    showPage.value = true;
  } else if (par['flg'] === 'f_close') {
    showPage.value = false;
  } else if (par['flg'] === 'bind_res') {

  } else if (par['flg'] === 'bind_trans2ids') {
  }
});
</script>

<style lang="scss" scoped>
.custom-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .custom-icon {
    object-fit: contain;
  }

  .svg-icon {
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain;
  }

  .icon-fallback {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    border-radius: 4px;
    font-size: 14px;
    color: #999;
  }
}
</style>